export default __webpack_public_path__ + "static/media/109.a7e318a5.jpg";